import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

const usePageStore = defineStore('page', () => {
  const currentStockId = ref(null)
  const currentIndicator = ref(null)
  const currentReportOptionSetting = ref({
    reportName: null,
    sheetType: null,
    graphType: null,
    yearRange: null,
    customYearRange: { start: null, end: null },
  })

  const shouldShowTagsIndicatorSection = computed(() => {
    const NO_SHOW_PAGE_LIST = [
      'dividend-policy',
      'e-report',
      'non-operating-income-to-profit-before-tax',
      'pe-band',
      'pb-band',
      'broker-trading',
      'long-term-and-short-term-monthly-revenue-yoy',
      'average-long-term-and-short-term-monthly-revenue',
      'croic',
      'piotroski-f-score',
      'financial-borrowing',
      'cash-conversion-cycle',
      'peter-lynch-valuation',
      'dividend-discount-valuation',
      'dcf-valuation',
      'majority-shareholders-share-ratio',
      'average-dividend-yield-band',
    ]
    return !NO_SHOW_PAGE_LIST.includes(currentIndicator.value)
  })

  const setCurrentStockId = ({ stockId }) => {
    currentStockId.value = stockId
  }

  const setCurrentIndicator = ({ indicator }) => {
    currentIndicator.value = indicator
  }

  const setCurrentReportOptionSetting = (reportSetting) => {
    currentReportOptionSetting.value = {
      ...currentReportOptionSetting.value,
      ...reportSetting,
    }
  }

  return {
    currentStockId,
    currentIndicator,
    currentReportOptionSetting,
    shouldShowTagsIndicatorSection,

    setCurrentStockId,
    setCurrentIndicator,
    setCurrentReportOptionSetting,
  }
})

export default usePageStore
